export const finance = [
  // 都是有侧边栏的基金页
  // 财务中间页-公允价值表(默认页面)
  {
    path: '/finance/fairvalueTable',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 基金搜索,点击进入fundChart
  {
    path: '/finance/fundManage/entitySearch',
    component: () => import(/* webpackChunkName: "fundManageEntitySearch" */ '@/views/finance/fundManage/entitySearch.vue')
  },
  // 基金管理-fundchart
  {
    path: '/finance/fundManage/list',
    component: () => import(/* webpackChunkName: "fundManageList" */ '@/views/finance/fundManage/list.vue'),
    meta: {
      title: '天池投资管理系统-北冥'
    }
  },
  // 财务数据中间页
  {
    path: '/finance/middlePage/list',
    component: () => import(/* webpackChunkName: "middlePageList" */ '@/views/finance/middlePage/list.vue')
  },
  // 基金授权列表
  {
    path: '/finance/fundAuth/list',
    component: () => import(/* webpackChunkName: "financeFundAuthList" */ '@/views/finance/fundAuth/list.vue')
  },
  // TODO 路由基金修改
  // 人民币主基金 	/finance/RMB/main
  {
    path: '/finance/RMB/main',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 美元主基金	 /finance/USD/main
  {
    path: '/finance/USD/main',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 人民币专项基金 	/finance/RMB/special
  {
    path: '/finance/RMB/special',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 美元专项基金 	/finance/USD/special
  {
    path: '/finance/USD/special',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 美元Feeder基金 	/finance/USD/special
  {
    path: '/finance/USD/feeder',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 人民币Feeder基金 	/finance/USD/special
  {
    path: '/finance/RMB/feeder',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  },
  // 人民币投资基金
  {
    path: '/finance/RMB/investFund',
    component: () => import(/* webpackChunkName: "fairvalueTable" */ '@/views/finance/fairvalueTable/fund.vue')
  }
];
